import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MasterDataService } from '../services/master-data.service';
import { FormsModule } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-access-privilege',
  templateUrl: './access-privilege.component.html',
  styleUrls: ['./access-privilege.component.css']
})
export class AccessPrivilegeComponent implements OnInit {
  @ViewChild('saveConfirmModal') saveConfirmModal: TemplateRef<any>;

  finalMenus: any[] = [];
  originalMenus: any[] = [];
  staticMenus = [];
  accessResponse: any;
  serviceVertical: any;
  serviceVerticalList: any;
  roleList: any;
  role: any;
  userId?: number;
  selectedMenu: any;
  modalChanges: any;
  assignedUsers: any[] = [];
  selectedUser: any = null;
  // viewMode: 'PERMISSIONS' | 'USERS' = 'PERMISSIONS';
  viewMode: 'PERMISSIONS' | 'USERS' | null = null;

  isEditMode = false;
  branchList;
selectedBranches: any[] = [];

  constructor(
    private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {

    this.loadServiceVerticals();
    this.loadRoles();
     this.selectedBranches = [];
    // this.userId = localStorage.getItem('id');
    this.masterDataService.getAllMenus().subscribe((menus: any) => {
      this.staticMenus = menus.menuSubmenus;
      console.log('static menus', this.staticMenus);
      // this.loadMenus();
    });

     this.masterDataService.getBranch().subscribe((res) => {
      this.branchList = res;
    });

  }

  toggleAllBranches() {
  if (this.selectedBranches.length === this.branchList.length) {
    this.selectedBranches = [];
  } else {
    this.selectedBranches = [...this.branchList]; 
  }

  this.onBranchChange();
}

onMenuSelect(menu: any) {
  this.selectedMenu = menu;

  // Initialize branch array if not present
  if (!menu.selectedBranches) {
    menu.selectedBranches = [];
  }

  // Bind UI selection to menu
  this.selectedBranches = menu.selectedBranches;

  if (!this.userId || !this.showBranchMultiSelect()) {
    this.selectedBranches = [];
    menu.selectedBranches = [];
  }
}

onBranchChange() {
  if (this.selectedMenu) {
    this.selectedMenu.selectedBranches = [...this.selectedBranches];
  }
}

showBranchMultiSelect(): boolean {

  if (!this.userId) return false;
  const name = this.selectedMenu?.displayName || this.selectedMenu?.name;

  return name === 'HR Reports' ||
         name === 'Account Reports' ||
         name === 'Partner Reports';
}

validateBranches(): boolean {
  if (!this.userId) return true;
  const allowedMenus = ['HR Reports', 'Account Reports', 'Partner Reports'];

  for (let menu of this.finalMenus) {
    const name = menu.displayName || menu.name;

    if (allowedMenus.includes(name) && menu.isEnabled) {
      if (!menu.selectedBranches || menu.selectedBranches.length === 0) {
        this.commonMessageService.swalAlertWithoutIcon(
          '',
          `Please select at least one branch for ${name}`
        );
        return false;
      }
    }
  }

  return true;
}

  isPermissionsView(): boolean {
    return this.viewMode === 'PERMISSIONS';
  }

  isUsersView(): boolean {
    return this.viewMode === 'USERS';
  }

  loadServiceVerticals() {
    this.masterDataService.getServiceVerticalList()
      .subscribe(res => {
        this.serviceVerticalList = res;
      })
  }

  loadRoles() {
    this.masterDataService.getRoles().subscribe((res) => {
      console.log(res);
      this.roleList = res;
    });
  }

  loadMenus(roleId: any, serviceVerticalId: any, userId?: number) {
    this.masterDataService.getUserMenus(roleId, serviceVerticalId, userId).subscribe((res) => {
      this.accessResponse = res.accessControl;
      // this.serviceVertical = res.serviceVertical;
      if (res.serviceVertical) {
        this.serviceVertical = this.serviceVerticalList.find(
          sv => sv.id === res.serviceVertical.id
        ) || this.serviceVertical;
      } else {
        this.serviceVertical = null;
      }

      this.role = res.role;
      console.log('accessResponse', res);
      // for (let i = 0; i < this.accessResponse.length; i++) {
      //   if (this.accessResponse[i].name == 'Managing Partner' && (this.userId != 52 && this.userId != 1074 && this.userId != 51 && this.userId != 53)) {
      //     this.accessResponse.splice(i, 1);
      //   }

      // }
      console.log('accessResponse', this.accessResponse);

      this.finalMenus = this.applyAccessControl(
        this.staticMenus,
        this.accessResponse
      );

      this.originalMenus = JSON.parse(JSON.stringify(this.finalMenus));

      if (this.finalMenus.length > 0) {
        this.selectedMenu = this.finalMenus[0];
      }
    });

  }

  applyAccessControl(staticMenus: any[], accessMenus: any[]) {
    const menuSet = new Set<number>();
    const subMenuSet = new Set<number>();
    const componentSet = new Set<number>();
    const subMenuComponentSet = new Set<number>();

    // 1️⃣ Build lookup sets from API response
    accessMenus.forEach(am => {
      if (!am?.menu) return;

      menuSet.add(am.menu.id);

      am.menu.submenus?.forEach(sm => {
        subMenuSet.add(sm.id);

        sm.subMenuComponents?.forEach(c => {
          subMenuComponentSet.add(c.id);
        });
      });

      am.menu.menuComponents?.forEach(c => {
        componentSet.add(c.id);
      });
    });

    // 2️⃣ Merge static menus with access flags
    return staticMenus.map(ms => {
  const menu = ms.menu;

  const accessMenu = accessMenus.find(am => am.menu?.id === menu.id);

  const isMenuEnabled = menuSet.has(menu.id);

  return {
    ...menu,
    isEnabled: isMenuEnabled,

    // ✅ ADD THIS
    selectedBranches: this.userId
      ? (accessMenu?.menu?.branches || [])
      : [],

    // MENU COMPONENTS
    menuComponents: (menu.menuComponents || []).map(c => ({
      ...c,
      isEnabled: componentSet.has(c.id) && isMenuEnabled
    })),

    // SUBMENUS
    submenus: (menu.submenus || []).map(sm => {
      const isSubMenuEnabled = subMenuSet.has(sm.id) && isMenuEnabled;

      return {
        ...sm,
        isEnabled: isSubMenuEnabled,

        subMenuComponents: (sm.subMenuComponents || []).map(c => ({
          ...c,
          isEnabled: subMenuComponentSet.has(c.id) && isSubMenuEnabled
        }))
      };
    })
  };
});
  }

  // Build Save Payload
  buildSavePayload() {
    return this.finalMenus
      .filter(menu => menu.isEnabled)
      .map(menu => ({
        menuId: menu.id,
        submenus: menu.submenus
          .filter(sm => sm.isEnabled)
          .map(sm => ({
            subMenuId: sm.id,
            components: sm.subMenuComponents
              .filter(c => c.isEnabled)
              .map(c => c.id)
          })),
        components: menu.menuComponents
          .filter(c => c.isEnabled)
          .map(c => c.id)
      }));
  }

  // Original State Getters
  getOriginalMenu(menuId: number) {
    return this.originalMenus.find(m => m.id === menuId);
  }

  getOriginalMenuComponent(menuId: number, compId: number) {
    return this.getOriginalMenu(menuId)
      ?.menuComponents?.find(c => c.id === compId);
  }

  getOriginalSubMenu(menuId: number, subMenuId: number) {
    return this.getOriginalMenu(menuId)
      ?.submenus?.find(sm => sm.id === subMenuId);
  }

  getOriginalSubMenuComponent(menuId: number, subMenuId: number, compId: number) {
    return this.getOriginalSubMenu(menuId, subMenuId)
      ?.subMenuComponents?.find(c => c.id === compId);
  }


  onMenuComponentChange(menu: any, comp: any) {

    this.toggleMenuComponent(menu);

    // Modification detection
    const original = this.getOriginalMenuComponent(menu.id, comp.id);
    comp.isModified = original?.isEnabled !== comp.isEnabled;
  }

  // Modification Detection Methods
  markMenuComponentModified(menu: any, comp: any) {
    const original = this.getOriginalMenuComponent(menu.id, comp.id);
    comp.isModified = original?.isEnabled !== comp.isEnabled;
  }

  markSubMenuModified(menu: any, sm: any) {
    const original = this.getOriginalSubMenu(menu.id, sm.id);
    sm.isModified = original?.isEnabled !== sm.isEnabled;
  }

  markSubMenuComponentModified(menu: any, sm: any, comp: any) {
    const original = this.getOriginalSubMenuComponent(menu.id, sm.id, comp.id);
    comp.isModified = original?.isEnabled !== comp.isEnabled;
  }

  // Toggle Methods
  toggleMenu(menu: any) {
    menu.submenus.forEach(sm => {
      sm.isEnabled = menu.isEnabled;
      sm.subMenuComponents.forEach(c => c.isEnabled = menu.isEnabled);
    });

    menu.menuComponents.forEach(c => c.isEnabled = menu.isEnabled);
  }

  toggleSubMenu(menu: any, subMenu: any) {
    // Flag submenu itself as modified only if its state changed
    subMenu.isModified = true;

    if (!subMenu.isEnabled) {
      // Submenu turned OFF → disable components and mark modified **only if they were ON**
      subMenu.subMenuComponents.forEach(c => {
        if (c.isEnabled) {
          c.isEnabled = false;
          c.isModified = true; // mark modified only if it actually changed
        }
      });
    }

    // Update parent menu's isEnabled flag
    menu.isEnabled = menu.submenus.some(sm => sm.isEnabled) ||
      menu.menuComponents.some(c => c.isEnabled);
  }

  calculatePermissionChanges() {
    let enabled = 0;
    let disabled = 0;

    this.finalMenus.forEach(menu => {

      // Menu Components
      menu.menuComponents?.forEach(c => {
        if (c.isModified) {
          c.isEnabled ? enabled++ : disabled++;
        }
      });

      // Submenus
      menu.submenus?.forEach(sm => {
        if (sm.isModified) {
          sm.isEnabled ? enabled++ : disabled++;
        }

        sm.subMenuComponents?.forEach(c => {
          if (c.isModified) {
            c.isEnabled ? enabled++ : disabled++;
          }
        });
      });
    });

    return {
      enabled,
      disabled,
      total: enabled + disabled
    };
  }



  toggleMenuComponent(menu: any) {
    let enabled = false;
    menu.menuComponents.forEach(c => enabled = enabled || c.isEnabled);
    menu.isEnabled = enabled;
  }

  onSave() {

    if (!this.validateBranches()) return;
    this.modalChanges = this.calculatePermissionChanges();

    this.modalService.open(this.saveConfirmModal, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
    }).result.then(
      (result) => {
        if (result === 'ok') {
          this.saveAccessControl();
        }
      },
      () => {
        // Modal dismissed (cancelled)
      }
    );
  }

  saveAccessControl() {
    console.log('Final Menus (UI State):', this.finalMenus);

    const payload = this.buildSavePayload();
    console.log('Save Payload:', payload);

    const formattedPayload = this.buildFinalSavePayload(payload);
    console.log('FINAL SAVE PAYLOAD:', formattedPayload);

    this.masterDataService.saveAccessControl(formattedPayload).subscribe((res) => {
      this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
      this.loadMenus(this.role.id, this.serviceVertical ? this.serviceVertical.id : 0, this.userId);
    }, (error) => {
      this.commonMessageService.swalAlertWithIcon('', 'Error Saving Access Control!', 'error');
    });
  }


  // onSave() {
  //   Swal.fire({
  //     text: 'Are you sure you want to save?',
  //     showCancelButton: true,
  //     confirmButtonText: 'Ok',
  //     confirmButtonColor: '#800000'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       console.log('Final Menus (UI State):', this.finalMenus);

  //       const payload = this.buildSavePayload();
  //       console.log('Save Payload:', payload);

  //       const formattedPayload = this.buildFinalSavePayload(payload);
  //       console.log('FINAL SAVE PAYLOAD:', formattedPayload);

  //       this.masterDataService.saveAccessControl(formattedPayload).subscribe((res) => {
  //         this.commonMessageService.swalAlertWithIcon('', 'Saved Successfully!', 'success');
  //         this.loadMenus(this.role.id, this.serviceVertical ? this.serviceVertical.id : 0);
  //       }, (error) => {
  //         this.commonMessageService.swalAlertWithIcon('', 'Error Saving Access Control!', 'error');
  //       });
  //     }
  //   });

  // }


  buildFinalSavePayload(savePayload: any[]) {
    const allowedMenus = ['HR Reports', 'Account Reports', 'Partner Reports'];
    const accessControl = this.finalMenus
      .filter(menu => menu.isEnabled)
      .map(menu => {
        const accessResponseMenu = this.accessResponse?.find(ar => ar.menu?.id === menu.id);
        const name = menu.displayName || menu.name;

        return {
          menu: {
            ...menu,

            branches: (this.userId && allowedMenus.includes(name))
                     ? (menu.selectedBranches || [])
                      : [],
            
            submenus: menu.submenus?.filter(sm => sm.isEnabled).map(sm => ({
              ...sm,
              subMenuComponents: sm.subMenuComponents?.filter(c => c.isEnabled) || []
            })) || [],
            menuComponents: menu.menuComponents?.filter(c => c.isEnabled) || []
          }
        };
      });

    // Final payload with role & serviceVertical
    return {
      role: this.role,
      serviceVertical: this.serviceVertical,
      user: this.userId ? this.selectedUser : null,
      accessControl
    };
  }

  compareById(obj1: any, obj2: any) {
    return obj1 && obj2 ? obj1.id === obj2.id : obj1 === obj2;
  }

  onRoleChange(selectedRole: any): void {
    if (selectedRole?.name === 'Article') {
      this.serviceVertical = null;
    }
  }

  onViewClick() {
    if (!this.role) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select Role first.');
      return;
    }
    if (this.role.name !== 'Article' && !this.serviceVertical) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select Service Vertical first.');
      return;
    }
    if (this.role) {
      const serviceVerticalId = this.serviceVertical ? this.serviceVertical.id : 0;
      this.userId = null;

      console.log('serviceVerticalId', serviceVerticalId);
      console.log('userRoleId', this.role.id);
      this.loadMenus(this.role.id, serviceVerticalId, this.userId);
    }
  }

  // onCancel() {
  //   this.role = null;
  //   this.serviceVertical = null;

  //   this.accessResponse = null;
  //   this.finalMenus = [];
  //   this.selectedMenu = null;
  //   window.scrollTo(0, 0);
  // }

  onCancel() {
    if (this.userId) {
      // Coming from USER edit → go back to users list
      this.userId = undefined;
      this.viewMode = 'USERS';
      this.finalMenus = [];
      this.selectedMenu = null;
      this.isEditMode = false;
      return;
    }

    // Normal role-based cancel
    this.role = null;
    this.serviceVertical = null;
    this.accessResponse = null;
    this.finalMenus = [];
    this.selectedMenu = null;
    window.scrollTo(0, 0);
  }


  hasAnyModification(): boolean {
    return this.finalMenus?.some(menu =>
      menu.menuComponents?.some(c => c.isModified) ||
      menu.submenus?.some(sm =>
        sm.isModified ||
        sm.subMenuComponents?.some(c => c.isModified)
      )
    );
  }

  fetchAssignedUsers() {
    if (!this.role) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select Role first.');
      return;
    }
    if (this.role.name !== 'Article' && !this.serviceVertical) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select Service Vertical first.');
      return;
    }
    this.assignedUsers = [];
    this.masterDataService.getUsersByRoleAndServiceVertical(this.role.id, this.serviceVertical ? this.serviceVertical.id : null).subscribe((res) => {
      console.log(res);
      if (res === null || res.length === 0) {
        this.commonMessageService.swalAlertWithoutIcon('','No users found for the selected Role and Service Vertical.');
        return;
      }
      res.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      this.assignedUsers = res;
    });
  }

  onEditUser(user: any) {
    this.userId = user.id;
    this.selectedUser = user;
    this.isEditMode = true;
    this.viewMode = 'PERMISSIONS';

    const serviceVerticalId = this.serviceVertical ? this.serviceVertical.id : 0;

    this.loadMenus(this.role.id, serviceVerticalId, this.userId);

    window.scrollTo(0, 0);
  }

  onBackToUsers() {
    this.isEditMode = false;
    this.viewMode = 'USERS';
  }

}
